/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSingleSelectFieldAnswer
 */
export interface ControlSingleSelectFieldAnswer {
    /**
     * 
     * @type {string}
     * @memberof ControlSingleSelectFieldAnswer
     */
    field_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSingleSelectFieldAnswer
     */
    selected: string;
}

/**
 * Check if a given object implements the ControlSingleSelectFieldAnswer interface.
 */
export function instanceOfControlSingleSelectFieldAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "selected" in value;

    return isInstance;
}

export function ControlSingleSelectFieldAnswerFromJSON(json: any): ControlSingleSelectFieldAnswer {
    return ControlSingleSelectFieldAnswerFromJSONTyped(json, false);
}

export function ControlSingleSelectFieldAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSingleSelectFieldAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field_type': !exists(json, 'field_type') ? undefined : json['field_type'],
        'selected': json['selected'],
    };
}

export function ControlSingleSelectFieldAnswerToJSON(value?: ControlSingleSelectFieldAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field_type': value.field_type,
        'selected': value.selected,
    };
}

